// Header mobile menu toggle
$(document).ready(function() {
	const $menuToggle = $('.header-menu-toggle');
	const $mobileMenu = $('.header-mobile-menu');
	const $iconOpen = $('.header-menu-icon-open');
	const $iconClose = $('.header-menu-icon-close');
	const $mobileLinks = $('.header-mobile-link');

	// Toggle menu
	$menuToggle.on('click', function() {
		$mobileMenu.toggleClass('is-open');
		$iconOpen.toggleClass('hidden');
		$iconClose.toggleClass('hidden');
	});

	// Close menu on link click
	$mobileLinks.on('click', function() {
		$mobileMenu.removeClass('is-open');
		$iconOpen.removeClass('hidden');
		$iconClose.addClass('hidden');
	});

	// Close menu on resize to desktop
	$(window).on('resize', function() {
		if (window.innerWidth >= 1024) {
			$mobileMenu.removeClass('is-open');
			$iconOpen.removeClass('hidden');
			$iconClose.addClass('hidden');
		}
	});

	// Telegram dropdowns (header + footer)
	$('.header-telegram-toggle, .footer-telegram-toggle').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var $dropdown = $(this).siblings('.header-telegram-dropdown, .footer-telegram-dropdown');
		$('.header-telegram-dropdown, .footer-telegram-dropdown').not($dropdown).removeClass('is-open');
		$dropdown.toggleClass('is-open');
	});

	$(document).on('click', function() {
		$('.header-telegram-dropdown, .footer-telegram-dropdown').removeClass('is-open');
	});

	$('.header-telegram-dropdown, .footer-telegram-dropdown').on('click', function(e) {
		e.stopPropagation();
	});
});
